// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slider_wrapper__3Huxq","slide":"slider_slide__2Hlyx","spa":"slider_spa__DArkm"};